module.exports = __webpack_public_path__ + "img/bmcl_gallery17.c695851c.jpg";